import React from "react"

const LogoSm = ({ className }: any) => {
  return (
    <svg version="1.1" id="Logo" x="0px" y="0px" className={className} viewBox="0 0 120 120">
      <path
        fill="currentColor"
        d="M108.5,7.7c-1.7,4.1-3.8,7.8-6.3,11.1C91.5,7.8,76.5,1,60,1C27.5,1,1,27.4,1,60c0,17,7.3,32.4,18.9,43.2
	l1.3,1.1c-2.2-1.8-2.5-4.9-0.7-7.1c1.8-2.2,4.9-2.5,7.1-0.7c2.2,1.8,2.5,4.9,0.7,7.1c-1.7,2.2-4.9,2.5-7.1,0.7l0.9,0.8
	c10.3,8.6,23.5,13.9,37.9,13.9c31.1,0,56.6-24.2,58.8-54.7C120.4,49.3,116,30.3,108.5,7.7z M108.2,85.9
	c-14.5,19.4-45.6,12.8-65.5,13.8c0,0-3.5,0.2-7.1,0.8c0,0,1.3-0.6,3.1-1.2c14-4.8,20.6-5.8,29.1-10.2c16-8.2,31.8-26,35.1-44.5
	C96.8,62.4,78.3,77.7,61.5,84c-11.5,4.3-32.3,8.4-32.3,8.4c0,0-0.8-0.4-0.8-0.4C14.2,85,13.8,54.3,39.5,44.5
	c11.3-4.3,22.1-2,34.3-4.9c13-3.1,28.1-12.8,34.2-25.6C114.8,34.4,123,66.2,108.2,85.9z"
      />
    </svg>
  )
}

export default LogoSm
